import { Radio } from '@cgn/framework-ui-components/v1';
import PropTypes from 'prop-types';
import React from 'react';

/**
*/
const ArgomentiRadios = ({ argomenti, argomento, onChange }) => (
  <>
    <span className="helpdesk-frontend-informazioni-aggiuntive__label text-bold">Argomento*</span>
    <div className="helpdesk-frontend-informazioni-aggiuntive__list">
      {argomenti.map((arg) => (
        <Radio
          key={arg.IdCategoria}
          checked={arg === argomento}
          label={arg.Categoria}
          onChange={() => { onChange(arg); }}
        />
      ))}
    </div>
  </>
);

ArgomentiRadios.propTypes = {
  argomenti: PropTypes.arrayOf(PropTypes.shape({
    IdCategoria: PropTypes.number.isRequired,
    Categoria: PropTypes.string.isRequired,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
  })),
  argomento: PropTypes.shape({
    IdCategoria: PropTypes.number.isRequired,
    Categoria: PropTypes.string.isRequired,
    EtichettaCampoAux1: PropTypes.string,
    EtichettaCampoAux2: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
};

ArgomentiRadios.defaultProps = {
  argomenti: [],
  argomento: undefined,
};

export default ArgomentiRadios;
